/**
 * V82.7 Phase 1: IP 화이트리스트 FE 타입
 */

export type IpWhitelistType = 'single' | 'cidr';
export type IpWhitelistStatus = 'active' | 'inactive';

export interface IpWhitelistRecord {
  id: string;
  ip: string;
  cidr?: string;
  type: IpWhitelistType;
  label?: string;
  memo?: string;
  status: IpWhitelistStatus;
  createdBy: string;
  createdByName?: string;
  createdAt: string;
  updatedAt: string;
  disabledBy?: string;
  disabledByName?: string;
  disabledAt?: string;
  enabledBy?: string;
  enabledByName?: string;
  enabledAt?: string;
}

export type SecurityAuditAction =
  | 'ip_whitelist_create'
  | 'ip_whitelist_disable'
  | 'ip_whitelist_enable'
  | 'ip_whitelist_update_memo';

export interface SecurityAuditLogRecord {
  id: string;
  action: SecurityAuditAction;
  actorId: string;
  actorName?: string;
  ipWhitelistId: string;
  targetIp: string;
  targetCidr?: string;
  before?: Record<string, any>;
  after?: Record<string, any>;
  reason?: string;
  createdAt: string;
}

export const SECURITY_AUDIT_ACTION_LABEL: Record<SecurityAuditAction, string> = {
  ip_whitelist_create: '신규 등록',
  ip_whitelist_disable: '비활성화',
  ip_whitelist_enable: '재활성화',
  ip_whitelist_update_memo: '메모 수정',
};
